import React, { useState, useRef, useEffect } from 'react';
import { useMessages } from '../../context/MessagesContext';
import { useSocket } from '../../hooks/useSocket';
import { Button } from '../common/Button';
import { FileAttachmentButton } from './FileAttachmentButton';

export function MessageInput() {
  const [message, setMessage] = useState('');
  const [attachedFile, setAttachedFile] = useState(null);
  const { 
    sendMessage, 
    setCurrentMessage, 
    setIsSelfDestructModalOpen, 
    setPendingSelfDestructMessage,
    currentMessage 
  } = useMessages();
  const { handleTyping } = useSocket();
  const typingTimeoutRef = useRef(null);

  useEffect(() => {
    if (currentMessage !== undefined && currentMessage !== message) {
      setMessage(currentMessage);
    }
  }, [currentMessage]);

const handleSend = () => {
  console.log('🔵 [MessageInput] handleSend called');
  console.log('🔵 [MessageInput] message:', message);
  console.log('🔵 [MessageInput] attachedFile:', attachedFile);
  
  if (message.trim() || attachedFile) {
    console.log('🟢 [MessageInput] Calling sendMessage with file:', !!attachedFile);
    sendMessage(message, false, null, attachedFile);
    setMessage('');
    setCurrentMessage('');
    setAttachedFile(null);
  } else {
    console.log('🔴 [MessageInput] Nothing to send');
  }
};

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleChange = (e) => {
    const newMessage = e.target.value;
    setMessage(newMessage);
    setCurrentMessage(newMessage);
    
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    
    handleTyping();
    
    typingTimeoutRef.current = setTimeout(() => {
      // Typing stopped
    }, 2000);
  };

  const handleSelfDestructClick = () => {
    if (!message.trim() && !attachedFile) {
      return;
    }
    setPendingSelfDestructMessage(message);
    if (setIsSelfDestructModalOpen) {
      setIsSelfDestructModalOpen(true);
    } else {
      window.dispatchEvent(new CustomEvent('openSelfDestructModal', { 
        detail: { message, file: attachedFile } 
      }));
    }
  };

  const handleFileSelected = (fileInfo) => {
    setAttachedFile(fileInfo);
  };

  const removeAttachedFile = () => {
    setAttachedFile(null);
  };

  useEffect(() => {
    return () => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="bg-white p-4 border-t border-gray-300">
      {attachedFile && (
        <div className="mb-2 p-2 bg-gray-100 rounded-lg flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <span className="text-xl">📎</span>
            <div>
              <p className="text-sm font-medium truncate">{attachedFile.fileName}</p>
              <p className="text-xs text-gray-500">
                {attachedFile.fileSize ? `${(attachedFile.fileSize / 1024).toFixed(1)} KB` : ''}
              </p>
            </div>
          </div>
          <button
            onClick={removeAttachedFile}
            className="text-gray-500 hover:text-red-500 transition"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      )}
      
      <div className="flex items-stretch space-x-2">
        <FileAttachmentButton 
          onFileSelected={handleFileSelected}
          disabled={false}
        />
        
        <input 
          type="text" 
          placeholder="Type your secure message..." 
          value={message} 
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          className="flex-grow p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none"
        />
        
        <button
          onClick={handleSelfDestructClick}
          className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg transition"
          title="Send self-destructing message"
        >
          ⏱️
        </button>
        
        <Button 
          onClick={handleSend} 
          disabled={!message.trim() && !attachedFile}
          variant="success"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
          </svg>
        </Button>
      </div>
    </div>
  );
}